import { READ, UPDATE, DELETE, SET_MAIN_PAGINATION_TOTAL } from '../../../../store/type'
import { MAIN_CONTACT } from "./type";
import { api } from "../../../../util/api";
import { API_METHODS } from "../../../../constant";

export const actions = {

    [MAIN_CONTACT + READ]: async({ state, rootState, commit }, paramsIn = null) => {
        try {
            if (paramsIn.id) {
                return await api(API_METHODS.GET_CONTACT, paramsIn, rootState)
            } else {
                const res = await api(API_METHODS.GET_ALL_CONTACT, paramsIn, rootState)
                commit(MAIN_CONTACT + READ, {
                    data: res.object,
                    fieldInfoList: res.fieldInfoList
                })
                commit(SET_MAIN_PAGINATION_TOTAL, {
                    countPage: res.countPage,
                })
                return res
            }
        } catch (err) {
            return (err)
        }
    },

    [MAIN_CONTACT + UPDATE]: async({ commit }, paramsIn = null) => {
        try {
            return await api(API_METHODS.UPDATE_CONTACT, paramsIn)
        } catch (err) {
            return (err)
        }
    },

    [MAIN_CONTACT + DELETE]: async({}, paramsIn = null) => {
        try {
            return await api(API_METHODS.DELETE_CONTACT, paramsIn)
        } catch (err) {
            return (err)
        }
    },
};